module.exports = __webpack_public_path__ + "media/images/placeholder-product-75389daed9249af0896e8b71a77ed46a.jpg";